/** 
 * 序列化参数
 * @param options {Object} - 需要序列化的参数对象
 * @return qsStr {String} - ex: '?a=1&b=2' 
 */

 const queryString = (options) => {
    if (!options) return
    let qsStr = ''
    let qsArr = []
    for (let key in options) {
        let str = `${key}=${options[key]}`
        qsArr.push(str)
    }
    qsStr = qsArr.join('&')
    qsStr && ('?' + qsStr)
    return qsStr
 }

 export default queryString